import Axios from "axios";

export function getErrorMessage(
  error: unknown,
  fallback: string,
): string {
  if (Axios.isAxiosError(error) && error.response?.data) {
    const data = error.response.data as {
      message?: string;
      errors?: Array<{ message?: string }>;
    };
    if (typeof data.message === "string") return data.message;
    if (data.errors?.[0]?.message) return data.errors[0].message;
  }
  if (error instanceof Error && error.message) return error.message;
  return fallback;
}
